import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { EDIT_SELECTOR } from "../../../../../crossconcern/utilities/properties/selector.property";
import { BaseComponent } from "../../../../base/base.component";
import { AppComponent } from "../../../../app.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { GenericService } from "../../../../../crossconcern/services/generic.services";
import { PhotosphereManager } from "../../../../../business/managers/photosphere.manager";
import { AlertUtils } from "../../../../../crossconcern/utilities/utils/alert.utils";
import { FormInfoField } from "../../../../../crossconcern/models/form/forminfofield";
import {
    FORM_TYPE_CHECKBOX, FORM_TYPE_FILE,
    FORM_TYPE_MULTISELECT,
    FORM_TYPE_TEXT,
    FORM_WIDTH_COL_4,
    FORM_WIDTH_OFFSET_COL_0
} from "../../../../../crossconcern/utilities/properties/base.property";
import { Validators } from "@angular/forms";
import { FormInfo } from "../../../../../crossconcern/models/form/forminfo";
import { Subscription } from "rxjs";
import { PRIVATE_PROMOTION_LIST_ROUTE } from "../../../../../crossconcern/utilities/properties/routename.property";
import { concatMap, finalize } from "rxjs/operators";
import { IDropdownSettings } from "ng-multiselect-dropdown/multiselect.model";
import { NurseryManager } from "app/business/managers/nursery.manager";

@Component({
    selector: EDIT_SELECTOR,
    templateUrl: "../edit/promotionedit.component.html"
})
export class PromotionNewComponent extends BaseComponent implements OnInit, OnDestroy {

    public formInfo: FormInfo;
    @ViewChild("formNursery", null) public formComponent;

    public selectedFiles: FileList[] = [];
    public promotionMediaUrl: unknown;

    public dropdownSettings: IDropdownSettings;

    private onGoBackCalledSubscription: Subscription;

    public titleText = "PROMOTION_NEW_COMPONENT_LABEL";

    constructor(
        protected appComponent: AppComponent,
        protected router: Router,
        protected location: Location,
        protected genericService: GenericService,
        private photosphereManager: PhotosphereManager,
        private nurseryManager: NurseryManager,
        private activeRoute: ActivatedRoute,
        protected alertUtils: AlertUtils) {
        super(appComponent, router, alertUtils, location);
        this.dropdownSettings = {
            singleSelection: false,
            idField: "id",
            textField: "text",
            enableCheckAll: false,
            allowSearchFilter: true
        };

        const formInfoFields: FormInfoField[] = [
            new FormInfoField(
                FORM_TYPE_TEXT,
                "PROMOTION_EDIT_COMPONENT_NAME",
                "name",
                [
                    Validators.required
                ],
                null,
                null,
                null,
                true,
                true,
                null,
                FORM_WIDTH_COL_4,
                FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(
                FORM_TYPE_TEXT,
                "PROMOTION_EDIT_COMPONENT_DESC",
                "desc",
                [
                    Validators.required
                ],
                null,
                null,
                null,
                true,
                true,
                null,
                FORM_WIDTH_COL_4,
                FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(
                FORM_TYPE_MULTISELECT,
                "PROMOTION_EDIT_COMPONENT_PRODUCTS",
                "products",
                [
                    Validators.required
                ],
                null,
                null,
                null,
                true,
                true,
                null,
                FORM_WIDTH_COL_4,
                FORM_WIDTH_OFFSET_COL_0,
                null,
                null,
                null,
                null,
                this.dropdownSettings),
            new FormInfoField(
                FORM_TYPE_MULTISELECT,
                "PROMOTION_EDIT_COMPONENT_NURSERIES",
                "nurseries",
                [
                    Validators.required
                ],
                null,
                null,
                null,
                true,
                true,
                null,
                FORM_WIDTH_COL_4,
                FORM_WIDTH_OFFSET_COL_0,
                null,
                null,
                null,
                null,
                this.dropdownSettings),
            new FormInfoField(
                FORM_TYPE_CHECKBOX,
                "PROMOTION_COMPONENT_FEATURED",
                "featured",
                [],
                null,
                null,
                null,
                true,
                false,
                null,
                FORM_WIDTH_COL_4,
                FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(
                FORM_TYPE_FILE,
                "PROMOTION_COMPONENT_IMAGE",
                "image",
                [],
                null,
                null,
                null,
                true,
                true,
                null,
                FORM_WIDTH_COL_4,
                FORM_WIDTH_OFFSET_COL_0,
                undefined,
                undefined,
                ".jpg,.jpeg,.png",
                true)
        ];

        this.formInfo = new FormInfo(formInfoFields, null);

        this.subscribeGenericServices();
    }

    public ngOnInit(): void {
        this.getProducts();
    }

    public ngOnDestroy() {
        this.unsubscribeServices();
    }

    private getProducts() {
        this.appComponent.startLoading();
        this.photosphereManager.getProducts()
            .pipe(
                concatMap((products) => {
                    this.formInfo.fields[2].values = products.map((prod) => {
                        const language = this.photosphereManager.getCurrentLanguage();
                        return {
                            id: prod.uuid,
                            text: this.getProductName(prod, language)
                        };
                    });
                    return this.nurseryManager.getNurseries(true, 10000, 0);
                }),
                finalize(() => this.appComponent.stopLoading())
            )
            .subscribe(([
                _, nurseries
            ]) => {
                this.formInfo.fields[3].values = nurseries.map((nursery) => {
                    return {
                        id: nursery.uuid,
                        text: nursery.name
                    };
                });

                this.formComponent.updateFormValues(this.formInfo);
            });
    }

    public onSavePromotion() {
        this.appComponent.startLoading();
        const newProds = this.formComponent.form.value.products.map((prod) => prod.id);
        const newNurseries = this.formComponent.form.value.nurseries.map((nursery) => nursery.id);
        this.photosphereManager.addPromotion({
            title: this.formComponent.form.value.name,
            description: this.formComponent.form.value.desc,
            featured: this.formComponent.form.value.featured
        }, { products: newProds }, { nurseries: newNurseries }, this.selectedFiles)
            .pipe(
                finalize(() => this.appComponent.stopLoading())
            )
            .subscribe(() => {
                this.goToRouteByName(PRIVATE_PROMOTION_LIST_ROUTE);
            });
    }

    public onFilesSelected(event) {
        this.selectedFiles = event;
    }

    private subscribeGenericServices() {
        this.onGoBackCalledSubscription = this.genericService.onGoBackCalled.subscribe(() => {
            this.goToRouteByName(PRIVATE_PROMOTION_LIST_ROUTE);
        });
    }

    private unsubscribeServices() {
        if(this.onGoBackCalledSubscription) {
            this.onGoBackCalledSubscription.unsubscribe();
        }
    }
}